import {Icon} from '~/components/icon'

const DOT_SIZE = 14

export const SelectItemDot = ({dotColor}) => {
	if (!dotColor) return null

	return <Icon name="dot" size={DOT_SIZE} fill={dotColor} />
}
